<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer017">
<h1 class="Title" id="_idParaDest-3"><a id="_idTextAnchor002">Just Cookies</a></h1><a id="_idTextAnchor002">
<p class="Normal-no-indent"><strong class="Strong _idGenCharOverride-2">Who am I talking
					about here?</strong> He says, “me want cookie!” or “me eat cookie!” or how about
				just “Om nom nom nom!” Yes, of course I’m talking about the Cookie Monster.</p>
<p class="Normal">And it’s easy to understanding why. Cookies are delicious! They are
				easy to make and you can make big batches of them to eat warm out of the oven and
				save the rest to eat in the future. I LOVE cookies. And I’ll guess you’re with me if
				the following words mean something to you: Thin Mints, Tagalongs, and Do-Si-Dos.
				Folks, <em class="Emphasis _idGenCharOverride-2">Troop Beverly Hills</em> wasn’t my
				favorite childhood movie for the cinematography—it was for the fact those boxes of
				cookies were the STAR of that film.</p>
<p class="Normal">But let’s face it, man cannot live on cookies alone because it’s not
				part of a well-balanced meal. <em class="Emphasis _idGenCharOverride-2">We all know
					that.</em> And for those fake “healthy” cookies that are high in protein, low in
				carbs, and have zero sugar, you, sir, are no cookie. You may be shaped like one, but
				you are what’s considered a round disc that’s a distant cousin of corrugated
				cardboard.</p>
<p class="Normal">So this chapter is what our crazy culinary team at <em class="Emphasis _idGenCharOverride-2">Naturally</em> came up with to satisfy my
				sweet tooth and make me feel a little less guilty in my indulgence. There are no
				diet fake-outs here. You see, these cookie recipes use real ingredients to make
				really good treats. But we’ve also swapped in clever things like vegetables
				(seriously, you’d never know) and all-natural sweeteners to replace processed sugar.
				And because we all have busy lives, they’re fast and easy to make. No piping bags.
				No French molds. No special trip to Williams Sonoma to get anything you don’t
				already have. Crunchy, crispy, and chewy . . . it’s all here. </p>
</a></div><a id="_idTextAnchor002">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer018">
<img alt="Photo of cookies." class="_idGenObjectAttribute-5" src="image/Opener_Image.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer019">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer020"><a id="_idTextAnchor002">
</a><h2 class="Heading-1" id="_idParaDest-4"><a id="_idTextAnchor002"></a><a id="_idTextAnchor003">The Famous Friday
				Chocolate Chip Cookies</a></h2><a id="_idTextAnchor003">
<p class="Recipe-Yield">Makes 48 cookies</p>
<p class="Recipe-Headnote">Every year, I go to this wellness spa in Mexico called Rancho
				La Puerta and do plenty of rigorous workouts, drink tons of water, and lay off the
				booze. The food there is also very healthy. But on Fridays there’s a treat, and it’s
				these insanely chewy chocolate chip cookies. After many years of asking for the
				recipe, I was able to get my hands on it and share it with you! </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup unsalted butter, softened</p>
<p class="Recipe-Ingredient">1/2	cup firmly packed brown sugar</p>
<p class="Recipe-Ingredient">2	eggs</p>
<p class="Recipe-Ingredient">1	cup milk</p>
<p class="Recipe-Ingredient">2	cups rolled oats</p>
<p class="Recipe-Ingredient">1	cup wheat germ</p>
<p class="Recipe-Ingredient">1	cup wheat flake cereal</p>
<p class="Recipe-Ingredient">1	cup white whole-wheat flour or whole-wheat pastry
				flour</p>
<p class="Recipe-Ingredient">1	cup sliced almonds</p>
<p class="Recipe-Ingredient">1	teaspoon cinnamon</p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient">1/2	teaspoon baking soda</p>
<p class="Recipe-Ingredient">1	cup semisweet chocolate chips</p>
<p class="Recipe-Ingredient">1/2	cup dried cranberries, chopped</p>
<p class="Recipe-Ingredient">48	chocolate kisses, unwrapped</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat the oven to 350°F.</li>
<li class="Recipe-Direction">In a stand mixer fitted with the paddle attachment,
					cream the butter and brown sugar. Add the eggs, 1 at a time, then the milk,
					beating until combined. (The milk will not quite combine with the butter well
					and the mixture will look a little separated, but this is fine.)</li>
<li class="Recipe-Direction">In a separate bowl, combine the oats, wheat germ,
					cereal, flour, almonds, cinnamon, baking powder, and baking soda. Add the
					chocolate chips and cranberries.</li>
<li class="Recipe-Direction">Add oat mixture to the milk mixture, and mix on the
					lowest speed until thoroughly combined.</li>
<li class="Recipe-Direction">Use a tablespoon measure or small ice cream scoop to
					scoop the dough onto lightly oiled baking sheets, leaving 2 inches between each
					scoop.</li>
<li class="Recipe-Direction">Press a chocolate kiss into the center of each
					cookie.</li>
<li class="Recipe-Direction">Bake for 14 minutes, or until lightly browned.</li>
</ol>
</a></div><a id="_idTextAnchor003">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer021">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-6" src="image/Chocolate_Chip_Cookie_0015-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer022">
<blockquote class="Caption">Photograph by Armando Rafael</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer023"><a id="_idTextAnchor003">
</a><h2 class="Heading-1" id="_idParaDest-5"><a id="_idTextAnchor003"></a><a id="_idTextAnchor004">Lemon-Scented <span class="no-break">Hemp Seed</span> Lace Cookies</a></h2><a id="_idTextAnchor004">
<p class="Recipe-Yield">Makes 12 cookies</p>
<p class="Recipe-Headnote">These delicate, crispy, and caramelized cookies are always a
				hit. They are also fantastic crumbled up on vanilla ice cream. By the way, if you
				don’t have a Silpat sheet, you can also use unbleached parchment paper. Don’t go
				without using; you won’t be able to gently pry them off an unlined cookie sheet.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1/4	cup hemp seeds</p>
<p class="Recipe-Ingredient">2-1/2	tablespoons whole-wheat pastry flour</p>
<p class="Recipe-Ingredient">1	tablespoon arrowroot powder</p>
<p class="Recipe-Ingredient">1	tablespoon melted coconut oil </p>
<p class="Recipe-Ingredient">2	tablespoons brown rice syrup</p>
<p class="Recipe-Ingredient">2-1/2	tablespoons maple syrup</p>
<p class="Recipe-Ingredient">1/2	teaspoon lemon extract</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">	Pinch of sea salt</p>
<h3 class="Heading-3">Make it </h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F. Line baking sheets with Silpat.
					Add hemp seeds, flour, and arrowroot to a medium bowl. Whisk to combine.</li>
<li class="Recipe-Direction">In separate bowl, whisk oil, rice syrup, maple syrup,
					lemon extract, and salt until thoroughly combined. Add to hemp mixture, mixing
					just until moistened. Let batter rest for 15 minutes.</li>
<li class="Recipe-Direction">Use a teaspoon to drop batter onto baking sheets,
					leaving space between cookies to allow spreading. Bake for 10 minutes
					until cookies are bubbly. Let cookies cool for approximately 30 seconds before
					removing onto wire rack. </li>
</ol>
</a></div><a id="_idTextAnchor004">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer024">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-7" src="image/141217_NATURALLY2626_FINAL.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer025">
<blockquote class="Caption">Photograph by David Engelhardt</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer026"><a id="_idTextAnchor004">
</a><h2 class="Heading-1" id="_idParaDest-6"><a id="_idTextAnchor004"></a><a id="_idTextAnchor005">Black and White
				Sesame Cookies</a></h2><a id="_idTextAnchor005">
<p class="Recipe-Yield">Makes approximately 20 cookies</p>
<p class="Recipe-Headnote">Sesame seeds are one of the original “superfoods.” They have
				two unique ingredients called sesamin and seamol, which have been shown to induce
				cholesterol reduction in a number of studies. It also has a strong nutty flavor that
				lends well in this sweet treat. </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1-1/2	cups whole-wheat pastry flour (I like
				Bob’s Red Mill) </p>
<p class="Recipe-Ingredient">1-1/2	teaspoons baking powder</p>
<p class="Recipe-Ingredient">1/4	teaspoon sea salt</p>
<p class="Recipe-Ingredient">3/4	cup well-emulsified tahini</p>
<p class="Recipe-Ingredient">1/3	cup coconut oil, melted</p>
<p class="Recipe-Ingredient">1/2	cup maple syrup</p>
<p class="Recipe-Ingredient">1/2	teaspoon vanilla extract</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/4	cup black and white sesame
				seeds</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F. Line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">In medium bowl, sift flour, baking powder, and salt
					together. In stand mixer, blend tahini, oil, maple syrup, and vanilla extract.
					Add flour mixture to tahini mixture in stand mixer and combine. </li>
<li class="Recipe-Direction">Using a 1-ounce scoop, form cookies onto baking sheets,
					sprinkle with sesame seeds, and press cookies down with back of fork.</li>
<li class="Recipe-Direction">Bake 10–15 minutes or until bottoms are golden brown.
					Remove cookies from pans to wire racks to cool.</li>
</ol>
</a></div><a id="_idTextAnchor005">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer027">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-8" src="image/141217_NATURALLY2660_FINAL.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer028">
<blockquote class="Caption">Photograph by David Engelhardt</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer029"><a id="_idTextAnchor005">
</a><h2 class="Heading-1" id="_idParaDest-7"><a id="_idTextAnchor005"></a><a id="_idTextAnchor006">Dark Chocolate–Ginger
				Macaroons</a></h2><a id="_idTextAnchor006">
<p class="Recipe-Yield">Makes 14 to 16 cookies</p>
<p class="Recipe-Headnote">Yes, dark chocolate can be good for you. It’s loaded with
				iron, magnesium, copper, zinc, and potassium. But as with most foods, these
				power-packed chewy, gooey, chocolate-y cookies should be eaten in moderation. </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1/2	cup semisweet dark chocolate pieces</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">2	large egg whites</p>
<p class="Recipe-Ingredient">1/2	cup plus 2 tablespoons maple crystals,
				ground</p>
<p class="Recipe-Ingredient">1/2	teaspoon vanilla extract</p>
<p class="Recipe-Ingredient">1	tablespoon ginger powder</p>
<p class="Recipe-Ingredient">1	cup unsweetened shredded coconut</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">3	tablespoons cocoa powder,
				sifted </p>
<h3 class="Heading-3">Make it </h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F. Line a baking sheet with
					parchment paper. </li>
<li class="Recipe-Direction">Using a double boiler, melt chocolate and set aside to
					cool. </li>
<li class="Recipe-Direction">In a medium bowl, add salt to egg whites and beat with
					electric mixer. Slowly add maple crystals to form soft peaks.</li>
<li class="Recipe-Direction">Using a spatula, fold in vanilla extract, ginger
					powder, and coconut. Add cocoa powder and cooled melted chocolate. Gently stir
					to incorporate all ingredients.</li>
<li class="Recipe-Direction">Using a 1-ounce scoop, scoop out cookies onto baking
					sheet leaving room for slight spread. Bake 15–20 minutes. Cool on wire
					racks.</li>
</ol>
</a></div><a id="_idTextAnchor006">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer030">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-9" src="image/141217_NATURALLY2684_FINAL-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer031">
<blockquote class="Caption">Photograph by David Engelhardt</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer032"><a id="_idTextAnchor006">
</a><h2 class="Heading-1" id="_idParaDest-8"><a id="_idTextAnchor006"></a><a id="_idTextAnchor007">Miniature Pink
				Raspberry Meringues </a></h2><a id="_idTextAnchor007">
<p class="Recipe-Yield">Makes 12 to 16 meringues</p>
<p class="Recipe-Headnote">Traditional meringues take hours in the oven, but can end
				with uneven results. Using a dehydrator works two ways to guarantee success: it
				delivers low and consistent heat and also blows out moisture. It’s a winning way to
				make perfect meringues every time. If you don’t have a dehydrator, it’s a good time
				to turn to your social network and ask: it’s worth the effort to borrow and give
				dehydrating a try.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">4	egg whites</p>
<p class="Recipe-Ingredient">1/2	teaspoon cream of tartar</p>
<p class="Recipe-Ingredient">2	cups organic evaporated cane juice</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	cup freeze-dried
				raspberries</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Add egg whites and cream of tartar to a large bowl. </li>
<li class="Recipe-Direction">Beat until soft peaks form then add sweetener, 1
					tablespoon at a time, until meringue is stiff. </li>
<li class="Recipe-Direction">Crush the raspberries into a fine powder and gently
					fold into mixture. Transfer into a lined pastry bag fitted with a star tip and
					pipe mixture onto a teflex or silicone-lined dehydrator tray.</li>
<li class="Recipe-Direction">Dehydrate at 140°F for 4 hours, or until crisp.</li>
</ol>
</a></div><a id="_idTextAnchor007">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer033">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-10" src="image/OO_Meringue_041-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer034">
<blockquote class="Caption">Photograph by Alexandra Grablewski</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer035"><a id="_idTextAnchor007">
</a><h2 class="Heading-1" id="_idParaDest-9"><a id="_idTextAnchor007"></a><a id="_idTextAnchor008">Red, White, And Blue
				Coconut Macaroons</a></h2><a id="_idTextAnchor008">
<p class="Recipe-Yield">Makes 12 macaroons</p>
<p class="Recipe-Headnote">Coconut meat is loaded in folates, riboflavin, niacin, and
				thiamin. Using a dehydrator helps preserve those vitamins, so these sweet treats are
				actually good for you.</p>
<p class="Subhead">Strawberry Macaroons </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup unsweetened, finely shredded coconut</p>
<p class="Recipe-Ingredient">1/2	cup coconut flour</p>
<p class="Recipe-Ingredient">2	tablespoons virgin coconut oil</p>
<p class="Recipe-Ingredient">1/4	cup coconut nectar</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1/2	teaspoon strawberry extract</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	cup freeze-dried
				strawberries</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Mix the coconut flakes, coconut flour, coconut oil,
					coconut nectar, salt, and strawberry extract in a medium bowl. </li>
<li class="Recipe-Direction">Crush freeze-dried berries by passing through a
					strainer, and fold into mixture. Using an ice cream scoop or tablespoon measure,
					scoop mixture onto teflex or silicone-lined dehydrator tray. </li>
<li class="Recipe-Direction">Dehydrate for 4 hours at 115°F, or until the outside of
					the macaroon is slightly firm, but the inside is still soft. </li>
</ol>
</a></div><a id="_idTextAnchor008">
<div class="Basic-Text-Frame" id="_idContainer036">
<p class="Subhead">Simply Coconut Macaroons</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup unsweetened, finely shredded coconut</p>
<p class="Recipe-Ingredient">1/2	cup coconut flour</p>
<p class="Recipe-Ingredient">2	tablespoons virgin coconut oil</p>
<p class="Recipe-Ingredient">1/4	cup coconut nectar</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	teaspoon coconut extract</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Mix the coconut flakes, coconut flour, coconut oil,
					coconut nectar, salt, and coconut extract in a medium bowl. </li>
<li class="Recipe-Direction">Using an ice cream scoop or tablespoon measure, scoop
					mixture onto teflex or silicone-lined dehydrator tray. </li>
<li class="Recipe-Direction">Dehydrate for 4 hours at 115°F, or until the outside of
					the macaroon is slightly firm, but the inside is still soft. </li>
</ol>
</div>
<div class="Basic-Text-Frame" id="_idContainer037">
<p class="Subhead">Blueberry Macaroons</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup unsweetened, finely shredded coconut</p>
<p class="Recipe-Ingredient">1/2	cup coconut flour</p>
<p class="Recipe-Ingredient">2	tablespoons virgin coconut oil</p>
<p class="Recipe-Ingredient">1/4	cup coconut nectar</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1/2	teaspoon almond extract</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	cup freeze-dried
				blueberries</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Mix the coconut flakes, coconut flour, coconut oil,
					coconut nectar, salt, and almond extract in a medium bowl.</li>
<li class="Recipe-Direction">Crush freeze-dried berries by passing through a
					strainer, and fold into mixture. Using an ice cream scoop or tablespoon measure,
					scoop mixture onto teflex or silicone-lined dehydrator tray. </li>
<li class="Recipe-Direction">Dehydrate for 4 hours at 115°F, or until the outside of
					the macaroon is slightly firm, but the inside is still soft. </li>
</ol>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer038">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-11" src="image/OO_Macaroon_014-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer039">
<blockquote class="Caption">Photograph by Alexandra Grablewski</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer040"><a id="_idTextAnchor008">
</a><h2 class="Heading-1" id="_idParaDest-10"><a id="_idTextAnchor008"></a><a id="_idTextAnchor009">Parsnip Oatmeal
				Raisin Cookies</a></h2><a id="_idTextAnchor009">
<p class="Recipe-Yield">Makes 24 cookies</p>
<p class="Recipe-Headnote">There’s no need to overload desserts with added sugars when
				you use whole food sources like parsnips and raisins. Naturally sweet, parsnips are
				an instant match for these oatmeal raisin cookies. It doesn’t hurt that they are
				also high in fiber, vitamin C, antioxidants, folic acid, and minerals including
				calcium and iron. </p>
<h3 class="Heading-3">Gather</h3>
<h4 class="Heading-4">Wet ingredients</h4>
<p class="Recipe-Ingredient">3/4	cup organic unsalted butter, softened to room
				temperature</p>
<p class="Recipe-Ingredient">1	cup organic brown sugar</p>
<p class="Recipe-Ingredient">2	organic eggs</p>
<p class="Recipe-Ingredient">2	teaspoons vanilla extract</p>
<h4 class="Heading-4">Dry ingredients</h4>
<p class="Recipe-Ingredient">1-1/2	cups whole-wheat flour</p>
<p class="Recipe-Ingredient">2	teaspoons ground cinnamon</p>
<p class="Recipe-Ingredient">1	tablespoon baking powder</p>
<p class="Recipe-Ingredient">1/2	teaspoon sea salt</p>
<p class="Recipe-Ingredient">2	cups rolled oats</p>
<h4 class="Heading-4">Add-ins</h4>
<p class="Recipe-Ingredient">2	medium parsnips, peeled and core removed</p>
<p class="Recipe-Ingredient">3/4	cup raisins</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">3	cups boiling water</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Add the butter and sugar to a large bowl. Use an
					electric mixer to beat the mixture for approximately 2 minutes or until
					fluffy.</li>
<li class="Recipe-Direction">Add in the eggs, 1 at a time, followed by the vanilla
					extract, and mix for additional minute. </li>
<li class="Recipe-Direction">In a separate bowl, sift in the flour, cinnamon, baking
					powder, and sea salt. Add in the oats, and stir to combine.</li>
<li class="Recipe-Direction">Using a food processor, pulse the parsnips until they
					form small, finely shredded pieces. Add to raisins, and cover mixture with
					boiling water. Allow to rest for 10 minutes. Drain thoroughly.</li>
<li class="Recipe-Direction">Slowly incorporate the dry ingredients into the wet
					ingredients, stirring with a rubber spatula until well combined. Fold the
					softened parsnips and raisins into the batter.</li>
<li class="Recipe-Direction">Chill cookie dough for 30 minutes in refrigerator.</li>
<li class="Recipe-Direction">In the meantime, preheat oven to 350°F and line baking
					sheets with parchment paper.</li>
<li class="Recipe-Direction">Scoop a heaping tablespoon of dough onto the baking
					sheet, flattening slightly and leaving 2 inches between each piece.</li>
<li class="Recipe-Direction">9Bake for 12 minutes. Place on wire rack to set and
					cool.</li>
</ol>
</a></div><a id="_idTextAnchor009">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer041">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-12" src="image/PARSNIP_RAISIN_COOKE_2-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer042">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer043"><a id="_idTextAnchor009">
</a><h2 class="Heading-1" id="_idParaDest-11"><a id="_idTextAnchor009"></a><a id="_idTextAnchor010">Ready-To-Eat Maple
				Chocolate Chip Cookie Dough</a></h2><a id="_idTextAnchor010">
<p class="Recipe-Yield">Makes 1 nice shareable bowl</p>
<p class="Recipe-Headnote">We’ve been told as children to <span class="sailec-medium _idGenCharOverride-3">never, ever</span> eat raw cookie
				dough because it’s not safe to eat due to raw eggs being in the mixture. Well, we’re
				not kids anymore, and this is a fully plant-based recipe that’s delicious all on its
				own. Stir into vanilla ice cream for the ultimate dessert. </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">2	cups almond flour</p>
<p class="Recipe-Ingredient">1	cup oat flour</p>
<p class="Recipe-Ingredient">1/4	teaspoon sea salt</p>
<p class="Recipe-Ingredient">1/2	cup maple syrup</p>
<p class="Recipe-Ingredient">2	teaspoons vanilla extract</p>
<p class="Recipe-Ingredient">1/4	cup almond butter</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	cup miniature dark chocolate
				chips</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Sift the almond flour, oat flour, and salt in a medium
					bowl, and set aside.</li>
<li class="Recipe-Direction">In a separate bowl, whisk together the maple syrup,
					vanilla extract, and almond butter.</li>
<li class="Recipe-Direction">Add the maple mixture into the flour mixture, stirring
					until evenly combined. </li>
<li class="Recipe-Direction">Fold in chocolate chips. Refrigerate dough for 10–20
					minutes, for a firmer texture.</li>
</ol>
</a></div><a id="_idTextAnchor010">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer044">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-13" src="image/20170405_NATURALLY_SUMMER_MAPLE-1-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer045">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer046"><a id="_idTextAnchor010">
</a><h2 class="Heading-1" id="_idParaDest-12"><a id="_idTextAnchor010"></a><a id="_idTextAnchor011">Almond Butter
				Gingersnap Cookies</a></h2><a id="_idTextAnchor011">
<p class="Recipe-Yield">Makes 12 cookies</p>
<p class="Recipe-Headnote">This is a classic cookie with a modern makeover, and it’s the
				perfect one to whip up during the holiday season. And guess what? This only takes 15
				minutes to bake to perfection.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup creamy almond butter</p>
<p class="Recipe-Ingredient">1	cup coconut sugar</p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient">2	teaspoons ground ginger</p>
<p class="Recipe-Ingredient">1	teaspoon ground cinnamon</p>
<p class="Recipe-Ingredient">1/2	teaspoon ground cloves</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">	Pinch of sea salt</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F. Line a baking sheet with
					parchment paper.</li>
<li class="Recipe-Direction">In a medium bowl, add the almond butter and coconut
					sugar. Stir with a spoon or with hands until dough forms. Allow mixture to rest
					for 5 minutes.</li>
<li class="Recipe-Direction">Add the baking powder, ginger, cinnamon, cloves, and
					salt to the dough, using hands to evenly work in ingredients. </li>
<li class="Recipe-Direction">Scoop 2 tablespoons of cookie batter and press between
					palms of hands to form a circular disc, approximately 1/4-inch thick.</li>
<li class="Recipe-Direction">Place formed cookie on baking sheet, and repeat with
					remaining batter, leaving space between each cookie.</li>
<li class="Recipe-Direction">Bake for 12 minutes then cool for a few minutes on the
					baking sheet before removing cookies and placing on a wire rack.</li>
</ol>
</a></div><a id="_idTextAnchor011">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer047">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-14" src="image/20170917_NATURALLY_WINTERRECIPES-4.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer048">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer049"><a id="_idTextAnchor011">
</a><h2 class="Heading-1" id="_idParaDest-13"><a id="_idTextAnchor011"></a><a id="_idTextAnchor012">Holiday Paleo Thin
				Mints</a></h2><a id="_idTextAnchor012">
<p class="Recipe-Yield">Makes 12 cookies</p>
<p class="Recipe-Headnote">What’s not to love? It tastes like a beloved Girl Scout
				cookie. It’s Paleo-friendly. And it has <span class="sailec-medium _idGenCharOverride-3">chocolate</span>. </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	cup almond flour</p>
<p class="Recipe-Ingredient">2	tablespoons cocoa powder</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">2	tablespoons coconut oil, melted</p>
<p class="Recipe-Ingredient">1/4	cup maple syrup</p>
<p class="Recipe-Ingredient">1	teaspoon peppermint extract, or more to taste</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	cup dark chocolate chips</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F. Line a baking sheet with
					parchment paper.</li>
<li class="Recipe-Direction">Place almond flour, cocoa powder, and salt in a medium
					bowl and stir to combine.</li>
<li class="Recipe-Direction">Fold in coconut oil, maple syrup, and peppermint
					extract until evenly incorporated.</li>
<li class="Recipe-Direction">Allow batter to rest for 10 minutes in the
					refrigerator.</li>
<li class="Recipe-Direction">Roll 1 tablespoon of cookie batter between palms of
					hands to form a ball and place on baking sheet. Press to flatten into
					approximately a 1/8-inch-thick disc.</li>
<li class="Recipe-Direction">Bake for 10 minutes then cool a few minutes on the
					baking sheet before removing to a wire rack. </li>
<li class="Recipe-Direction">Melt half the chocolate chips in a double boiler. Take
					off heat and fold in remainder of chocolate to temper the mixture.</li>
<li class="Recipe-Direction">Dip cookies in chocolate and place them back on the
					parchment-lined baking sheet. Or you can drizzle chocolate on top of
					cookies.</li>
<li class="Recipe-Direction">Refrigerate cookies for 15 minutes to set chocolate
					coating.</li>
</ol>
</a></div><a id="_idTextAnchor012">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer050">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-15" src="image/20170917_NATURALLY_WINTERRECIPES-9.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer051">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer052"><a id="_idTextAnchor012">
</a><h2 class="Heading-1" id="_idParaDest-14"><a id="_idTextAnchor012"></a><a id="_idTextAnchor013">Ice Box Maple
				Cookies</a></h2><a id="_idTextAnchor013">
<p class="Recipe-Yield">Makes 24 cookies</p>
<p class="Recipe-Headnote">Maple sugar makes a great white sugar substitute because it
				has the same sweetness level and a very similar fine texture. It also is
				lower on the glycemic index in comparison to white sugar, which means it raises
				blood sugar more slowly than the regular sweet stuff.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	stick (1/2 cup) unsalted butter, softened</p>
<p class="Recipe-Ingredient">1/4	cup maple sugar</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1	teaspoon vanilla extract</p>
<p class="Recipe-Ingredient">1	cup spelt flour</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	cup pecans, finely chopped </p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Add butter and maple sugar to a bowl and use a hand
					mixer to whisk for 2–3 minutes, or until creamed.</li>
<li class="Recipe-Direction">Add salt and vanilla extract and stir until
					combined.</li>
<li class="Recipe-Direction">Add in the flour in stages, whisking with hand mixer
					until incorporated.</li>
<li class="Recipe-Direction">Fold in pecans then place batter in freezer for 5–10
					minutes.</li>
<li class="Recipe-Direction">Using a rolling pin, roll out cookie dough into a
					1/4-inch thickness on 1 baking sheet. Place baking sheet into freezer so dough
					stiffens.</li>
<li class="Recipe-Direction">Cut out desired shapes using cookie cutters of choice,
					arranging on the other baking sheet.</li>
<li class="Recipe-Direction">Bake cookies for 10–12 minutes, or until lightly
					golden.</li>
</ol>
</a></div><a id="_idTextAnchor013">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer053">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-16" src="image/20170917_NATURALLY_WINTERRECIPES-36.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer054">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer055"><a id="_idTextAnchor013">
</a><h2 class="Heading-1" id="_idParaDest-15"><a id="_idTextAnchor013"></a><a id="_idTextAnchor014">Flourless Spiced
				Gingerbread Cookies</a></h2><a id="_idTextAnchor014">
<p class="Recipe-Yield">Makes 24 (1-inch) cookies</p>
<p class="Recipe-Headnote">Here’s a gluten-free cookie that actually tastes better
				without the gluten. Adding real ground ginger into this cookie not only helps with
				flavor but it helps with digestion and blood sugar levels as well.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1-1/2	cups almond flour</p>
<p class="Recipe-Ingredient">1/4	cup tapioca starch (arrowroot), more to dust</p>
<p class="Recipe-Ingredient">1	tablespoon ground ginger</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">2	tablespoons refined coconut oil</p>
<p class="Recipe-Ingredient">1/4	cup maple syrup</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	tablespoon molasses</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">In a large bowl, add almond flour, tapioca starch,
					ground ginger, and salt, stirring to combine.</li>
<li class="Recipe-Direction">Incorporate in the coconut oil, maple syrup, and
					molasses until dough forms.</li>
<li class="Recipe-Direction">Place dough in freezer for 15 minutes, and using a
					rolling pin, roll out on 1 baking sheet into approximately 1/4-inch thickness
					using additional tapioca starch to manage any sticking. </li>
<li class="Recipe-Direction">Place baking sheet in freezer for 5 minutes so dough
					stiffens. </li>
<li class="Recipe-Direction">Cut out shapes using desired cookie cutters, and place
					on other baking sheet.</li>
<li class="Recipe-Direction">Bake for 10–12 minutes.</li>
<li class="Recipe-Direction">Cool cookies, and drizzle with Nutmeg-Infused Icing, if
					using.</li>
</ol>
</a></div><a id="_idTextAnchor014">
<div class="Basic-Text-Frame" id="_idContainer056">
<p class="Subhead">Nutmeg-Infused Icing</p>
<p class="Recipe-Yield">Makes 1/4 cup</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1/2	cup organic confectioners’ sugar</p>
<p class="Recipe-Ingredient">1/4	teaspoon ground nutmeg</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1-1/2	teaspoons agave syrup</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1-1/2	teaspoons almond milk</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Add confectioners’ sugar, nutmeg, and salt to a small
					bowl and stir to combine.</li>
<li class="Recipe-Direction">Fold in agave syrup and almond milk to form icing.</li>
<li class="Recipe-Direction">Allow mixture to rest for 5 minutes then drizzle on
					cookies </li>
</ol>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer057">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-17" src="image/20170917_NATURALLY_WINTERRECIPES-7.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer058">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer059"><a id="_idTextAnchor014">
</a><h2 class="Heading-1" id="_idParaDest-16"><a id="_idTextAnchor014"></a><a id="_idTextAnchor015">Chewy
				Cauliflower—Black Sesame Cookies</a></h2><a id="_idTextAnchor015">
<p class="Recipe-Yield">Makes approximately 24 cookies</p>
<p class="Recipe-Headnote">Yes, cauliflower. This is no typo. Cauliflower is nutrient
				dense in vitamin C and K and has practically no calories. It’s also a blank canvas,
				meaning it can take on the flavor of whatever you’re cooking—or in this
				case—-baking. A few tips: The cauliflower has to be cooked to tender and completely
				blended for a cookie that holds together. And roasting the black sesame seeds will
				bring out the flavor.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">2	cups small cauliflower florets (approximately 6
				ounces)</p>
<p class="Recipe-Ingredient">1	(14-ounce) can coconut milk</p>
<p class="Recipe-Ingredient">3/4	cup maple syrup</p>
<p class="Recipe-Ingredient">2	teaspoons vanilla extract</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1/2	cup black sesame seeds</p>
<p class="Recipe-Ingredient">2	cups whole-wheat flour</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">2	teaspoons baking powder</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Place cauliflower, coconut milk, maple syrup, vanilla
					extract, and salt into a small pan. Bring to simmer, and cook for 10 minutes or
					until florets are tender.</li>
<li class="Recipe-Direction">Transfer mixture to wide container (will help cool
					quicker) and place in freezer to cool for 15 minutes. Note: It should still be
					warm.</li>
<li class="Recipe-Direction">Blend in blender until smooth. </li>
<li class="Recipe-Direction">Toast sesame seeds in a pan over medium heat for 2
					minutes, stirring occasionally.</li>
<li class="Recipe-Direction">Cool seeds and then combine with whole-wheat flour and
					baking powder in medium bowl. Fold in cauliflower mixture to flour mixture.</li>
<li class="Recipe-Direction">Scoop 2 tablespoons cookie dough onto baking sheets and
					bake on center-most racks for 15 minutes, or until lightly firm to the
					touch.</li>
<li class="Recipe-Direction">Transfer to wire racks to cool. Store in airtight
					container for 3–5 days.</li>
</ol>
</a></div><a id="_idTextAnchor015">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer060">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-18" src="image/Chewy_Cauliflower_Black_Sesame_Cookies.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer061">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer062"><a id="_idTextAnchor015">
</a><h2 class="Heading-1" id="_idParaDest-17"><a id="_idTextAnchor015"></a><a id="_idTextAnchor016">Parsnip—Brown Butter
				Sugar Cookies</a></h2><a id="_idTextAnchor016">
<p class="Recipe-Yield">Makes 24 cookies</p>
<p class="Recipe-Headnote">So, you might be asking: why parsnips? Sure, it has fiber,
				protein, and vitamins. But it’s also a fantastic add-in to help reduce the amount of
				butter you need in a recipe. Cooked parsnips do a beautiful job in emulsifying the
				ingredients, so you use less butter. Less butter means more
				cookies for you to eat. Got it?</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	medium parsnip</p>
<p class="Recipe-Ingredient">1	stick (1/2 cup) unsalted butter </p>
<p class="Recipe-Ingredient">1	cup coconut sugar</p>
<p class="Recipe-Ingredient">2	teaspoons vanilla extract</p>
<p class="Recipe-Ingredient">1	organic egg</p>
<p class="Recipe-Ingredient">2	teaspoons baking powder</p>
<p class="Recipe-Ingredient">1-1/2	cups whole-wheat flour</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	teaspoon flaky sea salt</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Peel and dice parsnip (approximately 1-3/4 cups), and
					place in small pot. Cover with cold water, bring to boil, and cook for 10
					minutes, or until tender. Drain, spread onto a plate and cool in freezer for 10
					minutes.</li>
<li class="Recipe-Direction">Place butter into a pan and cook over medium heat for
					3 minutes or until golden. Transfer into bowl and place in freezer for
					10 minutes to cool. </li>
<li class="Recipe-Direction">Cream together cooled butter, cooled parsnip, and
					coconut sugar for 2 minutes using a stand or electric hand mixer. </li>
<li class="Recipe-Direction">Add vanilla extract and egg and continue to beat for
					additional minute, scraping down edges as needed. Whisk baking powder into flour
					and fold into wet mixture.</li>
<li class="Recipe-Direction">Scoop 1-ounce (2 tablespoons) rounds onto baking sheet,
					placing 12 cookies per tray approximately 2 inches apart. Use a fork to gently
					flatten and sprinkle with sea salt. Bake on center-most racks for 16–18 minutes,
					or until lightly golden.</li>
<li class="Recipe-Direction">Transfer to wire rack to cool. Store in airtight
					container for 3–5 days.</li>
</ol>
</a></div><a id="_idTextAnchor016">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer063">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-19" src="image/Parship_Brown_Suger_Cookies.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer064">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer065"><a id="_idTextAnchor016">
</a><h2 class="Heading-1" id="_idParaDest-18"><a id="_idTextAnchor016"></a><a id="_idTextAnchor017">Beet, Aquafaba, and
				Rose Macarons</a></h2><a id="_idTextAnchor017">
<p class="Recipe-Yield">Makes 18 cookies (36 halves)</p>
<p class="Recipe-Headnote">Listen, this won’t be a recipe that’s an everyday staple in
				your baking repertoire. But it’s not difficult either. It just takes a few extra
				steps to make truly one of the most decadent cookies you’ve ever made at home. And
				in case you’re wondering what aquafaba is, it’s basically the milky brine
				in a can of chickpeas. So save it and give these a whirl! </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">3/4	cup no-salt-added aquafaba (1 can of
				chickpeas)</p>
<p class="Recipe-Ingredient">1	small beet</p>
<p class="Recipe-Ingredient">3/4	cup organic cane sugar, sifted and divided</p>
<p class="Recipe-Ingredient">3/4	cup almond flour, sifted</p>
<p class="Recipe-Ingredient">1/2	teaspoon cream of tartar</p>
<p class="Recipe-Ingredient">1/4	teaspoon rose water, or to taste</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	cup seedless raspberry
				jam</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 275°F (no fan), and line 2 baking
					sheets with parchment paper.</li>
<li class="Recipe-Direction">Place aquafaba in small pot and reduce for 10 minutes
					over medium heat, or until reduced to 1/3 cup.</li>
<li class="Recipe-Direction">Cool mixture completely in freezer for 15 minutes.</li>
<li class="Recipe-Direction">Grate beet and press through a strainer to extract
					juice into a bowl.</li>
<li class="Recipe-Direction">Sift 1/4 cup sugar and almond flour into a medium bowl
					and whisk to combine; set aside. </li>
<li class="Recipe-Direction">Use stand or electric hand mixer to beat the cooled
					chickpea reduction on high speed. Sift in the cream of tartar after 30
					seconds.</li>
<li class="Recipe-Direction">Add remaining sugar by the tablespoon after mixture
					starts to foam.</li>
<li class="Recipe-Direction">Beat on high for 3–5 minutes, or until stiff glossy
					peaks form.</li>
<li class="Recipe-Direction">Gently fold in flour mixture into whipped mixture. Stir
					in beet juice (approximately 2 tablespoons) and rosewater.</li>
<li class="Recipe-Direction">Use a small metal spoon to spoon 2-inch mounds of
					batter onto baking sheets. </li>
<li class="Recipe-Direction">Bake on center rack for 25–30 minutes, or until
					slightly firm to the touch. Allow to cool completely before transferring onto
					wire rack. Note: If transferred when still hot, they will stick to the parchment
					paper.</li>
<li class="Recipe-Direction">Add 1 teaspoon jam between 2 macarons, repeating for
					remainder of cookies. </li>
<li class="Recipe-Direction">Enjoy or place in refrigerator to soften for a few
					hours before consuming. </li>
</ol>
</a></div><a id="_idTextAnchor017">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer066">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-20" src="image/Beet_Aquafaba_Rose_Macarons.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer067">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer068"><a id="_idTextAnchor017">
</a><h2 class="Heading-1" id="_idParaDest-19"><a id="_idTextAnchor017"></a><a id="_idTextAnchor018">Gluten-Free Zucchini
				Muesli Cookies</a></h2><a id="_idTextAnchor018">
<p class="Recipe-Yield">Makes 18 cookies</p>
<p class="Recipe-Headnote">Healthy? Check. Zero gluten? Yep. Could you grab these and
				eat them for breakfast? You absolutely freaking could. These are the most
				guilt-free cookies in the bunch. By the way, zucchini is added for two reasons: to
				slip in some veg and keep these cookies moist and chewy.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	medium zucchini</p>
<p class="Recipe-Ingredient">1/2	cup refined coconut oil</p>
<p class="Recipe-Ingredient">1	cup gluten-free muesli (substitute granola for the
				muesli for a sweeter finish)</p>
<p class="Recipe-Ingredient">3/4	cup coconut sugar</p>
<p class="Recipe-Ingredient">1/4	cup ground flax seeds </p>
<p class="Recipe-Ingredient">1	cup gluten-free flour mix (I like Bob’s Red
				Mill)</p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">	Pinch of sea salt</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Shred zucchini into a medium bowl (approximately 1-1/2
					cups).</li>
<li class="Recipe-Direction">Melt coconut oil and stir into zucchini.</li>
<li class="Recipe-Direction">In a separate bowl, stir together muesli, coconut
					sugar, ground flax, flour mix, baking powder, and salt; fold into zucchini
					mixture.</li>
<li class="Recipe-Direction">Allow mixture to rest for 5 minutes to activate
					flax.</li>
<li class="Recipe-Direction">Using a 2-tablespoon scoop, drop cookies onto baking
					sheets, leaving 2 inches of space in between as cookies will spread. Bake on
					center-most racks for 15–18 minutes, or until golden and firm to the touch.</li>
<li class="Recipe-Direction">Cool on wire rack. Cookies can be stored in an airtight
					container for 3–5 days.</li>
</ol>
</a></div><a id="_idTextAnchor018">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer069">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-21" src="image/Gluten_Free_Zuchini_Muesili_Cookies.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer070">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer071"><a id="_idTextAnchor018">
</a><h2 class="Heading-1" id="_idParaDest-20"><a id="_idTextAnchor018"></a><a id="_idTextAnchor019">Vegetable Juice
					<span class="no-break">Fortune-S</span>haped Cookies</a></h2><a id="_idTextAnchor019">
<p class="Recipe-Yield">Makes 20 cookies</p>
<p class="Recipe-Headnote">This could easily enter Martha Stewart recipe territory (as
				in, who is crazy enough to make something you get for <span class="sailec-medium _idGenCharOverride-3">free</span> in Chinese takeout?), but
				it just looks like it’s a Martha-only recipe, I swear. You’d only go into
				Martha-land if you made custom paper fortunes embossed with gold leaf to slip into
				each of your homemade fortune cookies. So, don’t . . . . </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">3/4	cup no-salt-added aquafaba (1 can of
				chickpeas)</p>
<p class="Recipe-Ingredient">1/2	teaspoon cream of tartar </p>
<p class="Recipe-Ingredient">1/2	cup organic cane sugar</p>
<p class="Recipe-Ingredient">3/4	cup whole-wheat flour</p>
<p class="Recipe-Ingredient">3	tablespoons refined coconut oil, melted</p>
<p class="Recipe-Ingredient">1	teaspoon vanilla extract</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">3	tablespoons vegetable juice
				(carrot, beet, kale, or juice of choice)</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 275°F and place an ovenproof rack on a
					baking sheet.</li>
<li class="Recipe-Direction">Place aquafaba in small pan and reduce for about 5
					minutes, or by half. Cool completely in freezer for 15 minutes.</li>
<li class="Recipe-Direction">Add cream of tartar to aquafaba using a stand or
					electric hand mixer and whip on high speed for 2 minutes or until fluffy. Add
					sugar while continuing to beat. Gently sift and fold flour into aquafaba
					mixture.</li>
<li class="Recipe-Direction">Add coconut oil to mixture along with vanilla extract
					and vegetable juice. Or split batter into 3 bowls and add 1 tablespoon of juice
					to each bowl, using different juices. Add a few tablespoons of water to form a
					thin pancake batter consistency.</li>
<li class="Recipe-Direction">Warm nonstick pan over low heat. Working in batches,
					pour 1 tablespoon of batter into a thin 3-inch round. Cook for 4–5 minutes and
					gently fold in half using a small flexible spatula. Use spatula to curve cookie
					into a fortune shape by pushing the edges inward. Transfer onto rack and repeat
					process with remaining batter.</li>
<li class="Recipe-Direction">Cookies are ready to eat, or can be baked for 20–25
					minutes to attain a crisper texture.</li>
</ol>
</a></div><a id="_idTextAnchor019">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer072">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-22" src="image/Vegetable_Juice_Fortune.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer073">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer074"><a id="_idTextAnchor019">
</a><h2 class="Heading-1" id="_idParaDest-21"><a id="_idTextAnchor019"></a><a id="_idTextAnchor020">Spinach—<span class="no-break">Peppermint Crème</span> Whoopie Pies</a></h2><a id="_idTextAnchor020">
<p class="Recipe-Yield">Makes 7 assembled whoopie pies</p>
<p class="Recipe-Headnote">I’m not going to lie and tell you these are the best looking
				whoopie pies you’ve ever seen. Actually, the green frosting kind reminds me of
				really creamy, slightly thinned out guacamole. They are, however, delicious. A great
				recipe to make for kids who love gross looking but delicious treats. But if the
				green filling is throwing you off, just omit the spinach.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">3	cups baby spinach</p>
<p class="Recipe-Ingredient">1	cup cashews</p>
<p class="Recipe-Ingredient">1/2	teaspoon peppermint extract, or to taste</p>
<p class="Recipe-Ingredient">1	cup agave nectar, divided</p>
<p class="Recipe-Ingredient">	Pinch of sea salt</p>
<p class="Recipe-Ingredient">1/2	cup cocoa powder</p>
<p class="Recipe-Ingredient">1-1/2	cups oat flour</p>
<p class="Recipe-Ingredient">2	tablespoons ground flax seeds</p>
<p class="Recipe-Ingredient">1-1/2	teaspoons baking powder</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	(14-ounce) can coconut
				milk</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Fill medium pot halfway with water and bring to a boil.
					Add spinach and cashews and cook for 15 seconds or until spinach is wilted.
					Drain into a colander positioned in a sink and rinse with cold water until
					cool.</li>
<li class="Recipe-Direction">Place spinach and cashews in blender, along with
					peppermint extract, 1/2 cup of agave nectar and salt and process until smooth.
					Chill in refrigerator until ready to use.</li>
<li class="Recipe-Direction">Whisk together cocoa powder, oat flour, ground flax
					seeds, and baking powder in a medium bowl.</li>
<li class="Recipe-Direction">Stir in remaining agave nectar and coconut milk until
					batter forms.</li>
<li class="Recipe-Direction">Spoon 1/4 cup mounds onto baking sheets, using a spoon
					to spread in approximate 3-inch circles, leaving approximately 2 inches
					in between each mound.</li>
<li class="Recipe-Direction">Bake for 18 minutes, or until cookies spring back to
					the touch. Cool.</li>
<li class="Recipe-Direction">Spread 2 heaping tablespoons of spinach peppermint
					crème onto the flat side of 1 cookie and use additional cookie to create the
					whoopie pie. Repeat with remainder of cookies and crème.</li>
<li class="Recipe-Direction">Store refrigerated in airtight container for 3–5
					days.</li>
</ol>
</a></div><a id="_idTextAnchor020">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer075">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-23" src="image/Spinach_Peppermint_Creme_Whoopie_Pies.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer076">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer077"><a id="_idTextAnchor020">
</a><h2 class="Heading-1" id="_idParaDest-22"><a id="_idTextAnchor020"></a><a id="_idTextAnchor021">Root Vegetable
				Fun-fetti Cookies</a></h2><a id="_idTextAnchor021">
<p class="Recipe-Yield">Makes 24 cookies</p>
<p class="Recipe-Headnote">There was some controversy over a word in this recipe. And
				that word is “optional.” I objected, because how can you make a “fun-fetti” cookie
				if you don’t have colorful sprinkles on top? So I must insist: if you omit the
				sprinkles, just tell folks you made a “root vegetable cookie.” That said, it’s a
				keeper and the candied ginger root is the hero ingredient that adds a
				lively sweetness to these cookies.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">3	medium multi-colored carrots</p>
<p class="Recipe-Ingredient">1/2	cup candied ginger root</p>
<p class="Recipe-Ingredient">3/4	cup coconut sugar</p>
<p class="Recipe-Ingredient">1-1/2	cups whole-wheat flour</p>
<p class="Recipe-Ingredient">2	tablespoons ground flax seeds</p>
<p class="Recipe-Ingredient">1-1/2	teaspoons baking powder</p>
<p class="Recipe-Ingredient">2	cans coconut cream (approximately 1-1/2 cups)</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">3/4	cup natural sprinkles
				(optional)</p>
<h3 class="Heading-3">Make</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Peel and grate carrots (approximately 1-3/4 cups
					total).</li>
<li class="Recipe-Direction">Chop candied ginger and set aside.</li>
<li class="Recipe-Direction">Whisk together coconut sugar, flour, flax seeds, and
					baking powder in a medium bowl.</li>
<li class="Recipe-Direction">Fold in carrot mixture, chopped candied ginger, and
					coconut cream until batter forms. Do not over mix.</li>
<li class="Recipe-Direction">Scoop batter using 1-ounce scoop onto baking sheets,
					leaving 2-inches between each cookie. </li>
<li class="Recipe-Direction">If a more colorful cookie is desired, sprinkle each
					cookie with sprinkles, pressing the sprinkles gently into the batter.</li>
<li class="Recipe-Direction">Bake on center-most racks for 18–20 minutes, or until
					lightly golden and slightly firm to the touch.</li>
</ol>
</a></div><a id="_idTextAnchor021">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer078">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-24" src="image/Root_Vegetable_FunFetti_Cookies.jpg"/>
</div>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer079"><a id="_idTextAnchor021">
</a><h2 class="Heading-1" id="_idParaDest-23"><a id="_idTextAnchor021"></a><a id="_idTextAnchor022">Paleo Sweet
				Potato—Cinnamon Crunch Cookies</a></h2><a id="_idTextAnchor022">
<p class="Recipe-Yield">Makes approximately 30 cookies</p>
<p class="Recipe-Headnote">If you think doing a Paleo diet means desserts are a thing of
				the past, think again. I love these cookies because they don’t taste <span class="sailec-medium _idGenCharOverride-3">healthy</span>. Instead, they are
				sweet, spicy, moist, and hit the spot when you just want a little something sweet.
				And, yes, you can have more than just one.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1-1/2	cups pecans, divided</p>
<p class="Recipe-Ingredient">1	medium sweet potato</p>
<p class="Recipe-Ingredient">1	can coconut cream (approximately 2/3 cup)</p>
<p class="Recipe-Ingredient">8	Medjool dates, pitted</p>
<p class="Recipe-Ingredient">4	teaspoons ground cinnamon</p>
<p class="Recipe-Ingredient">2	cups almond flour </p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/4	teaspoon sea salt </p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Toast 1 cup of pecans in oven for 5 minutes, reserving
					remaining half cup for garnish. Cool and chop coarsely.</li>
<li class="Recipe-Direction">Peel and dice sweet potato (approximately 2 cups).
					Place in small pot, cover with water, bring to a boil, and cook for 10 minutes,
					or until tender.</li>
<li class="Recipe-Direction">Drain and transfer to a blender, along with coconut
					cream. Add dates along with cinnamon and blend until smooth.</li>
<li class="Recipe-Direction">In a medium bowl, stir together almond flour, chopped
					pecans, baking powder, and salt.</li>
<li class="Recipe-Direction">Stir in wet mixture into almond flour mixture.</li>
<li class="Recipe-Direction">Scoop cookies using 1-ounce scoop onto baking sheets.
					Top with remaining pecans by pressing 1 gently atop each cookie and bake on
					center-most racks for 18–20 minutes.</li>
<li class="Recipe-Direction">Transfer onto wire rack to cool, and store in airtight
					container for 3–5 days.</li>
</ol>
</a></div><a id="_idTextAnchor022">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer080">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-25" src="image/Paleo_Sweet_Potato_Cinnamon_Crunch.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer081">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer082"><a id="_idTextAnchor022">
</a><h2 class="Heading-1" id="_idParaDest-24"><a id="_idTextAnchor022"></a><a id="_idTextAnchor023">Black Cocoa “Oreos”
				with Cauliflower Crème</a></h2><a id="_idTextAnchor023">
<p class="Recipe-Yield">makes 28 sandwich cookies</p>
<p class="Recipe-Headnote">Yes, we came up a healthy version of the American classic
				Oreo. And, yes, it only took us five years to figure it out. You see,
				cauliflower turns out to be the hero veg to use for the crème; it has just enough of
				a subtle cultured flavor akin to cream cheese. </p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1-1/2	cups cauliflower florets</p>
<p class="Recipe-Ingredient">1	cup cashews</p>
<p class="Recipe-Ingredient">1-3/4	cups organic cane sugar, divided</p>
<p class="Recipe-Ingredient">1/8	teaspoon sea salt</p>
<p class="Recipe-Ingredient">3/4	cup black cocoa powder</p>
<p class="Recipe-Ingredient">1	cup whole-wheat flour </p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient">2	tablespoons ground flax seeds</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1	(14-ounce) can coconut
				milk</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Place cauliflower florets and cashews into a small pot
					and cover with water.</li>
<li class="Recipe-Direction">Bring to a boil and cook for 5 minutes or until
					tender.</li>
<li class="Recipe-Direction">Drain and blend cauliflower and cashews in blender
					along with 1 cup sugar and salt, processing until smooth. Cool completely in
					refrigerator.</li>
<li class="Recipe-Direction">Whisk together remaining sugar, cocoa powder, flour,
					baking powder, and ground flax in a medium bowl.</li>
<li class="Recipe-Direction">Fold in coconut milk.</li>
<li class="Recipe-Direction">Using a 1-tablespoon measure, scoop batter onto baking
					sheets and use a spoon to flatten into approximate 1-inch rounds. Cookies will
					spread, so leave 1–2 inches between rounds.</li>
<li class="Recipe-Direction">Bake on center-most oven racks for 16–18 minutes or
					until firm to the touch and transfer onto a wire rack.</li>
<li class="Recipe-Direction">Reduce oven heat to 250°F and place rack of cookies
					back onto baking tray and dry out for at least 25 minutes, or longer if crispier
					cookies are desired. Cool completely.</li>
<li class="Recipe-Direction">Before serving, spread 1 tablespoon of crème onto half
					the cookies and use remainder of the cookies to press into a sandwich,
					positioning flat side of sandwiching cookie upward.</li>
</ol>
</a></div><a id="_idTextAnchor023">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer083">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-26" src="image/Black_Cocoa_Oreos_with_Cauli_Creme.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer084">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer085"><a id="_idTextAnchor023">
</a><h2 class="Heading-1" id="_idParaDest-25"><a id="_idTextAnchor023"></a><a id="_idTextAnchor024">Chewy
				Chocolate-Avocado Protein Cookies</a></h2><a id="_idTextAnchor024">
<p class="Recipe-Yield">Makes approximately 21 cookies</p>
<p class="Recipe-Headnote">Are you on the collagen bandwagon? Collagen is a flavorless
				and odorless high-protein amino acid that your body needs for a healthy gut,
				flexible joints, strong muscles, and to even look younger with less wrinkles. I put
				a scoop of collagen in my coffee every morning, but it can also be added to things
				you bake. In this case, the collagen is more than a booster, it also helps bind the
				batter. And the avocado has 3 purposes: sweetness, fat, and moisture to help
				emulsify everything together.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	ripe avocado</p>
<p class="Recipe-Ingredient">3/4	cup agave nectar</p>
<p class="Recipe-Ingredient">2	teaspoons vanilla extract</p>
<p class="Recipe-Ingredient">1/4	cup unflavored collagen powder</p>
<p class="Recipe-Ingredient">1	cup quinoa flour</p>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient">1	cup dark chocolate chips</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	teaspoon flaky sea salt</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Process avocado, agave nectar, and vanilla extract in
					food processor or blender until smooth.</li>
<li class="Recipe-Direction">In a medium bowl, whisk together collagen powder,
					quinoa flour, and baking powder.</li>
<li class="Recipe-Direction">Fold in puréed avocado mixture and chocolate
					chips.</li>
<li class="Recipe-Direction">Use a 1-ounce scoop to transfer cookies onto baking
					sheets.</li>
<li class="Recipe-Direction">Bake on center-most racks for 18–20 minutes or until
					golden and lightly firm to the touch.</li>
<li class="Recipe-Direction">Transfer to wire rack to cool; store in airtight
					container for 3–5 days.</li>
</ol>
</a></div><a id="_idTextAnchor024">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer086">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-27" src="image/Chewy_Chocolate_Avo_Protein_Cookies.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer087">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer088"><a id="_idTextAnchor024">
</a><h2 class="Heading-1" id="_idParaDest-26"><a id="_idTextAnchor024"></a><a id="_idTextAnchor025">Avocado Boston Cream
				Pie Cookies</a></h2><a id="_idTextAnchor025">
<p class="Recipe-Yield">Makes 18 cookies</p>
<p class="Recipe-Headnote">If you learn one thing from this chapter, it’s this: Regular
				‘ole cocoa powder mixed with agave syrup creates an instant and insanely delicious
				chocolate sauce. And that sauce goes even better on these Boston cream pie
				cookies. BTW, we add turmeric to the custard to give it a nutritional boost and a
				custard-like glow.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	ripe avocado</p>
<p class="Recipe-Ingredient">1-3/4	cups agave syrup, divided</p>
<p class="Recipe-Ingredient">1	tablespoon vanilla extract, divided</p>
<p class="Recipe-Ingredient">1-1/2	cups gluten-free flour mix (I like Bob’s Red
				Mill)</p>
<p class="Recipe-Ingredient">1-1/2	teaspoons baking powder</p>
<p class="Recipe-Ingredient">2	tablespoons organic cornstarch</p>
<p class="Recipe-Ingredient">1	cup coconut milk</p>
<p class="Recipe-Ingredient">	Pinch of ground turmeric </p>
<p class="Recipe-Ingredient _idGenParaOverride-1">1/2	cup cocoa powder</p>
<h3 class="Heading-3">Make it</h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F, and line 2 baking sheets with
					parchment paper.</li>
<li class="Recipe-Direction">Purée avocado, 3/4 cup agave syrup, and 1 teaspoon
					vanilla extract in food processor or blender.</li>
<li class="Recipe-Direction">Whisk together flour mix and baking powder in a medium
					bowl. Fold in avocado mixture.</li>
<li class="Recipe-Direction">Use a 1-ounce scoop to transfer cookies onto baking
					sheets.</li>
<li class="Recipe-Direction">Bake on center-most racks for 16–18 minutes or until
					golden and lightly firm to the touch and transfer to wire rack to cool.</li>
<li class="Recipe-Direction">Dissolve cornstarch in a small bowl with a few
					tablespoons of water, add to small pan along with coconut milk, 1/2 cup agave
					syrup, and remaining vanilla extract and bring to a simmer.</li>
<li class="Recipe-Direction">Whisk for 2–5 minutes on a medium heat or until mixture
					thickens. Stir in turmeric and take off heat to cool.</li>
<li class="Recipe-Direction">Add remaining agave syrup and cocoa powder to a small
					pan. Stir on low heat until cocoa powder dissolves.</li>
<li class="Recipe-Direction">Place 1 tablespoon of custard on each cookie and top
					with chocolate spread. Note: For neater appearance, place chocolate mixture into
					piping bag and pipe onto each cookie.</li>
</ol>
</a></div><a id="_idTextAnchor025">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer089">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-28" src="image/Avocado_Boston_Cream_Pie_Cookies-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer090">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a><div class="Basic-Text-Frame" id="_idContainer091"><a id="_idTextAnchor025">
</a><h2 class="Heading-1" id="_idParaDest-27"><a id="_idTextAnchor025"></a><a id="_idTextAnchor026">Matcha-Dusted <span class="no-break">Gluten-Free</span> Almond Biscotti</a></h2><a id="_idTextAnchor026">
<p class="Recipe-Yield">Makes 12 biscotti</p>
<p class="Recipe-Headnote">If you’d like to make this biscotti totally plant based, just
				replace the eggs with 2 tablespoons of ground chia or flax seeds. These are
				excellent with a cup of coffee.</p>
<h3 class="Heading-3">Gather</h3>
<p class="Recipe-Ingredient">1	teaspoon baking powder</p>
<p class="Recipe-Ingredient">1-1/2	cups almond flour</p>
<p class="Recipe-Ingredient">1	cup sorghum flour</p>
<p class="Recipe-Ingredient">1/3	cup refined coconut oil</p>
<p class="Recipe-Ingredient">1/3	cup maple syrup</p>
<p class="Recipe-Ingredient">1	organic egg</p>
<h4 class="Heading-4">Garnish</h4>
<p class="Recipe-Ingredient">1/2	cup slivered almonds, more for garnish</p>
<p class="Recipe-Ingredient">1/2	cup dark chocolate chips</p>
<p class="Recipe-Ingredient _idGenParaOverride-1">2	teaspoons matcha powder</p>
<h3 class="Heading-3">Make it </h3>
<ol>
<li class="Recipe-Direction">Preheat oven to 350°F and line a baking sheet with
					parchment paper. </li>
<li class="Recipe-Direction">Sift together baking powder, almond flour, and sorghum
					flour in a bowl. Stir to combine.</li>
<li class="Recipe-Direction">Warm coconut oil briefly until melted. Remove from heat
					and stir in maple syrup and beat in egg.</li>
<li class="Recipe-Direction">Pour oil mixture into flour mixture, folding until
					combined. Mixture will be sticky.</li>
<li class="Recipe-Direction">Roll dough in almonds and form a log that measures
					approximately 12 x 3 inches long. Place on center of baking sheet and bake for
					25 minutes or until golden.</li>
<li class="Recipe-Direction">Cool for a few minutes and slice into 1-inch slices and
					place slices back on wire rack. </li>
<li class="Recipe-Direction">Place wire rack on top of baking sheet and bake for
					additional 10–15 minutes.</li>
<li class="Recipe-Direction">Melt 1/4 cup chocolate chips over double boiler. Remove
					from heat and stir in remaining chocolate to temper mixture.</li>
<li class="Recipe-Direction">Spread chocolate mixture on top half of biscotti and
					dust with matcha powder. Top with extra almonds.</li>
</ol>
</a></div><a id="_idTextAnchor026">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer092">
<img alt="Photo of recipe above." class="_idGenObjectAttribute-29" src="image/Mat_Biscotti_012-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer093">
<blockquote class="Caption">Photograph by Alexandra Grablewski</blockquote>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Naturally_Delicious_Desserts_Interiors-2.vue?89605ab4